// extracted by mini-css-extract-plugin
export default {"title":"NewAdvertising_title__3Eq6y","boxForm":"NewAdvertising_boxForm__kG3K1","form":"NewAdvertising_form__MxZKD"};